import { useEffect, useState } from 'react'

interface Props {
  timestamp: string | null | Date
}

function relativeTime(from: Date, to: Date): string {
  const diffMs = to.getTime() - from.getTime()
  const seconds = Math.floor(diffMs / 1000)

  if (seconds < 5) return 'just now'
  if (seconds < 60) return `${seconds}s ago`
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes} min ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  return `${days}d ago`
}

/**
 * Displays a timestamp as relative time ("2 min ago"), self-refreshing
 * every 10 seconds. Hovering shows the absolute timestamp.
 */
export function RelativeTime({ timestamp }: Props) {
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 10_000)
    return () => clearInterval(timer)
  }, [])

  if (!timestamp) return <span>Never</span>

  const date = timestamp instanceof Date ? timestamp : new Date(timestamp)
  return (
    <time dateTime={date.toISOString()} title={date.toLocaleString()}>
      {relativeTime(date, now)}
    </time>
  )
}
